<template>
  <div v-resize="resizeHandler">
    <el-tooltip
        v-if="!manual && showPopper"
        v-bind="$attrs"
        :effect="effect"
        :popper-class="pClass"
        :manual="manual"
        v-model="show"
    >
      <div ref="mxRemark" :class="tClass" style="width: 100%">
        <slot name="default"/>
      </div>
      <template #content>
        <div v-if="content">{{content}}</div>
        <div v-else-if="$slots.content">
          <slot name="content"/>
        </div>
        <div v-else>
          <slot name="default"/>
        </div>
      </template>
    </el-tooltip>
    <div ref="mxRemark" :class="tClass" v-else>
      <slot name="default"/>
    </div>
  </div>
</template>

<script>
export default {
  // 自定义文字超出缩略组件，传入content参数或插槽#content为弹窗显示的内容
  name: 'MxRemark',
  props: {
    content: {
      type: String
    },
    effect: {
      type: String,
      default: 'light'
    },
    showPopper: {
      type: Boolean,
      default: true
    },
    popperClass: {
      type: String
    },
    // 显示文本行数，最大为5行
    lineNumber: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      manual: false,
      show: false
    }
  },
  computed: {
    pClass () {
      if (this.popperClass) {
        return this.popperClass + ' mx-text-overflow_popper'
      }
      return 'mx-text-overflow_popper'
    },
    tClass () {
      if (this.lineNumber && this.lineNumber > 0 && this.lineNumber < 5) {
        return 'remark-span-' + parseInt(this.lineNumber)
      }
      return 'remark-span-1'
    }
  },
  updated () {
    // this.$nextTick(() => {
    //   this.init()
    // })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let dom = this.$refs.mxRemark
      if (!dom) return
      // 单行使用宽度判断是否有省略
      if (this.tClass === 'remark-span-1') {
        let w1 = dom.scrollWidth
        let w2 = dom.clientWidth
        if (w1 > w2) {
          this.manual = false
        } else {
          this.manual = true
        }
      } else { // 多行使用高度判断是否有省略
        let h1 = dom.scrollHeight
        let h2 = dom.clientHeight
        if (h1 > h2) {
          this.manual = false
        } else {
          this.manual = true
        }
      }
    },
    resizeHandler () {
      this.init()
    }
  }
}
</script>

<style
    scoped
    lang="scss"
>
  .remark-span-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
  }
  @for $i from 2 to 5 {
    .remark-span-#{$i} {
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: #{$i};
      -webkit-box-orient: vertical;
    }
  }
</style>
<style lang="scss">
  .mx-text-overflow_popper {
    font-size: $font-size-normal;
    max-width: 480px;
    line-height: 1.666 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/mx-remark/index.vue